import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '@/lib/utils';
import { Input } from './ui/input';

interface CustomInputProps {
    $centerText?: boolean;
}

export interface BasicInputProps extends InputHTMLAttributes<HTMLInputElement>, CustomInputProps {}

export const BasicInput = forwardRef<HTMLInputElement, BasicInputProps>(
    ({ $centerText, className, width, style, ...props }, ref) => {
        return (
            <Input
                ref={ref}
                className={cn(
                    'h-auto px-3 py-3 text-base [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
                    $centerText && 'text-center',
                    className,
                )}
                style={{ width, ...style }}
                {...props}
            />
        );
    },
);

BasicInput.displayName = 'BasicInput';
